import { render, staticRenderFns } from "./MethodBlock.vue?vue&type=template&id=422e0d66&lang=pug&"
import script from "./MethodBlock.vue?vue&type=script&lang=js&"
export * from "./MethodBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports